// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2109":"32b91f52041e14b6","3543":"488fc02e24eb8207"}[chunkId] + ".js";
};